import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { useSessionContext } from 'contexts/session';

interface Param {
  skip?: boolean;
}

export const useReferralData = ({ skip }: Param = {}) => {
  const { userId } = useSessionContext();
  const {
    data: referralData,
    loading,
    error,
  } = useQuery<GetReferralDataQuery, GetReferralDataQueryVariables>(
    GET_REFERRAL_DATA,
    {
      skip,
      variables: { id: userId },
    }
  );

  const data = useMemo(() => {
    if (loading || error || !referralData) return undefined;
    const { shareableReferralCode } = referralData.user;
    const { accounts } = referralData.user;
    if (!accounts) return undefined;
    const excludeSavingsLanguage = !accounts.some(
      account => account.shouldProvideReferralBonus
    );
    return {
      excludeSavingsLanguage,
      shareableReferralCode,
    };
  }, [referralData, error, loading]);

  return { data, error, loading };
};

export const GET_REFERRAL_DATA = gql`
  query getReferralData($id: Int!) {
    user(id: $id) {
      id
      shareableReferralCode
      accounts {
        id
        shouldProvideReferralBonus
      }
    }
  }
`;

export const getReferralDataMock = {
  user: {
    accounts: [
      {
        shouldProvideReferralBonus: true,
        id: 1,
      },
    ],
    id: 10,
    shareableReferralCode: 'lauren3566',
  },
};

export const useReferralDataMock = {
  data: { excludeSavingsLanguage: false, shareableReferralCode: 'lauren3566' },
  error: undefined,
  loading: false,
};
